import { makeStyles } from '@material-ui/core';

interface TopAreaProps {
  leftHanded: boolean;
}

export const styles = makeStyles(() => ({
  topArea: {
    flexGrow: 1,
  },
  rightArea: ({ leftHanded }) => ({ flexDirection: leftHanded ? 'row-reverse' : 'row' }),
  buttonItem: ({ leftHanded }: TopAreaProps) => ({
    marginLeft: leftHanded ? 0 : '0.73vw',
    marginRight: !leftHanded ? 0 : '0.73vw',
    '@media (aspect-ratio: 4/3)': {
      marginLeft: leftHanded ? 0 : '0.5vw',
      marginRight: !leftHanded ? 0 : '0.5vw',
    },
  }),
  weightItem: {
    marginRight: 20,
  },
  weightItemInverse: {
    marginLeft: 20,
    direction: 'ltr',
  },
  liveWeightContainer: {
    width: 'auto',
    minWidth: '18vw',
    justifyContent: 'flex-end',
    '@media (aspect-ratio: 4/3)': {
      minWidth: '22vw',
    },
  },
  retailerLogoContainer: { marginRight: '3vw' },
  retailerLogo: {
    height: '6.87vh',
    display: 'flex',
  },
}));
